import { useState } from 'react';
import { Button } from '@material-ui/core';
import { Form } from '@rocketseat/unform';
import * as Yup from 'yup';
import history from '../../services/history';
import logoCorreios from '../../assets/logo-correios.svg';
import ReactGA from 'react-ga';
import './recaptcha.css';
import { toast } from 'react-toastify';
import { Redirect } from "../../components/Redirect/Redirect";

const schema = Yup.object().shape({
    codigoRastreio: Yup.string()
        .required('O código de rastreio é obrigatório')
});

const URL_CORREIOS = "https://rastreamento.correios.com.br/"

const Rastreio = () => {
    ReactGA.pageview('/RastreioBuscaCorreios');

    const [codigo, setCodigo] = useState(history.location?.state);
    if (!codigo || codigo == '') {
        history.push('/')
    }

    const [open, setOpen] = useState(false);
    const [isCopy, setIsCopy] = useState(false);

    function handleClickOpen() {
        setOpen(true);
    }

    async function handleSubmit(data) {
        handleClickOpen()
    }

    function handleCopyCode(data) {
        navigator.clipboard.writeText(data)
            .then(() => {
                toast.success('Código de Rastreio copiado para a área de transferência!');
                setIsCopy(true)
            })
            .catch((error) => {
                toast.info(error)
            })
    }

    document.title = 'Portal de Rastreio Correios - Magazord'
    return (
        isCopy ? (
            <Redirect url={URL_CORREIOS} />
        ) : (
            <div className="container-form">
                <div className="box-form">
                    <div className="box-info">
                        <img src={logoCorreios} alt="Logo Correios" className="logo-correios"/>
                        <p>O código de rastreio do seu pedido nos Correios é:</p>
                        <h1>{codigo}</h1>
                        <p>Clique no botão abaixo para copiar e ser redirecionado para o site dos Correios</p>
                    </div>
                    <Form schema={schema} onSubmit={handleSubmit}>
                        <Button className="btn-default busca-correios" onClick={() => handleCopyCode(codigo)} value="Acessar">
                            Copiar
                        </Button>
                    </Form>
                </div>
            </div>
        )
    )
}

export default Rastreio;